/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_Reason_AccessInputs */

const fr_household_reason_access = /** @type {(inputs: Household_Reason_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas d'accès à ce cours`)
};

/**

* @param {Household_Reason_AccessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_reason_access = /** @type {((inputs?: Household_Reason_AccessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Reason_AccessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_reason_access(inputs)
});